import React, { useEffect, useState, useRef } from "react";

import { auth, firebase } from "../../Firebase/config";

import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  FieldValue,
  getCountFromServer,
} from "@firebase/firestore";

import axios from "axios";

import {
  Link,
  Route,
  Routes,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import "../Messages.css";

export default function Phonelessstudents({
  currentclass,
  activename,
  setSelectedclass,
  activeid2,
  activename2,
  selectedclass,
  currentstudent,
  setCurrentstudent,
  studentidd,
  parentlanguagecode,
  id2,
  temparray,
  activeid,
  id,
  role,
  assignmentname,
  assignmentid,
  accesstokenn,
  refreshtokenn,
  expirydatee,
  localemailaddress

}) {

  const [lasttwomonths, setlasttwomonths] = useState([]);

  const [searchingstate, setSearchingstate] = useState(false);
  const [aallpasses, setAallpasses] = useState();

  const [filteredstates, setFilteredstates] = useState([]);

  const [activpasses, setActivpasses] = useState([]);
  const [update, setUpdate] = useState();

  const [changehasbeenmade, setChangehasbeenmade] = useState();
  const [endtime, setEndtime] = useState();
  const [begintime, setBegintime] = useState();

  const [revise, setRevise] = useState();

  const [passesbetween, setPassesbetween] = useState();

  const [currentclass2, setCurrentclass2] = useState();
  const [activeid22, setActiveid2] = useState();

  const [website, setWebsite] = useState();
  const [whatparentssee, setWhatpareentseee] = useState();
  const [thispage, setThispage] = useState();

  const navigate = useNavigate();



  const selectHandler = (value, i) => {

    if (value && assignmentid != value.id) {
      setSelectedclass(value);
    } else {
      setSelectedclass("");
    }

  };

  useEffect(() => {
    setThispage(window.location.href)

  }, []);


  async function getassignmentdatafromgc() {
    if (typeof assignmentid != "undefined") {

         localStorage.setItem("parentorstudentnotetimesent", Date.now().toString());
         localStorage.setItem("parentorstudentnote", "parents");

          if (selectedclass && selectedclass.key) {
        localStorage.setItem("activeid", selectedclass.key);
      }

      const databasecourseId = localStorage.getItem("activeid");

      const API_BASE_URL = "https://api-hkshnm7duq-uc.a.run.app";
      const currentUrl = window.location.href;
      // Get the current URL

      const isProduction = process.env.NODE_ENV === "production";
      const baseUrl = isProduction ? "https://fastclasspass.web.app" : "http://localhost:3000";
      const redirectUrl = `${baseUrl}/Messagesforsending/role/Teacher/mainmenu/id/${id}`;


      try {
        const response = await axios.get(`${API_BASE_URL}/api/login`, {

          params: {
            state: JSON.stringify({
              id: id, // Pass "id" as a query parameter
              currentUrl: currentUrl, // Include the current URL as state
              task: "fetchGradesOfSelectedAssignment",
              //Make the couseid and databasecourseId dynamic
              redirectUrl: redirectUrl,
              assignmentid: assignmentid,
              email: localemailaddress,
              // Explicitly include redirectUrl
              courseId: activeid2, // Ensure "courseId" is sent with a capital "I"
                databasecourseId: databasecourseId, 
            }),
          },// Include cookies if necessary
        });

        // Log the authUrl received from the backend
        console.log("Auth URL:", response.data.authUrl);

        // Redirect the user to the authUrl
        if (response.data.authUrl) {
          window.open(response.data.authUrl, "_blank", "noopener,noreferrer");
        } else {
          console.error("Auth URL not received from the server.");
          alert("Failed to retrieve the authentication URL.");
        }
      } catch (error) {
        console.error(
          "Error during login:",
          error.response?.data || error.message
        );
        alert("Failed to initiate login. Please check the console for details.");
      }
    }
  }

  return (
    <div className="inner123">
      {typeof temparray != "undefined" ? (
        <>
         
           {typeof assignmentid == "undefined" ? <div className="centerme295">Select <br />Google Classroom Assignment<br></br><br></br></div>: <div className="centerme295">Selected <br />Google Classroom Assignment<br></br><br></br></div>}
          {temparray.map((item, index) => (
            <React.Fragment key={item.id || index}>

              {typeof assignmentid == "undefined" ? (
                <div onClick={() => selectHandler(item, index)}>
                  <div
                    className="passstart2225"
                  >
                    <div className="innertext" onClick={() => console.log("select")}>
                      {item.title} <br></br>
                      {item.dueDate.month ? "Due: " + item.dueDate.month + "/" + item.dueDate.day + "/" + item.dueDate.year : "No Due Date"}
                    </div>
                    <div></div>
                  </div>
                </div>
              ) : typeof assignmentid != "undefined" &&
                assignmentid != item.id ? null : (
                <>
                  <div
                    className="passstart2225" onClick={() => selectHandler(item, index)}
                  >
                    <div className="innertext" onClick={() => console.log("select")}>
                      {item.title} <br></br>
                      {item.dueDate.month ? "Due: " + item.dueDate.month + "/" + item.dueDate.day + "/" + item.dueDate.year : "No Due Date"}
                    </div>
                    <div></div>
                  </div>
                  <br></br>

                  {typeof assignmentid != "undefined" ? <div className="passstart222">
                    <div
                      className="innertext"
                      onClick={() => getassignmentdatafromgc()}
                    >
                      Message About This Assignment
                    </div>
                  </div> : null}

                </>
              )}
            </React.Fragment>
          ))}
        </>
      ) : null}
      <br></br>
    </div>
  );
}

/* <View>
<div
  style={
    item.id === idselected ? styles.selected : styles.unselected
  }
  onClick={() => selectHandler(item)}>
  <div style={styles.end}>{item.firstname} {item.lastname}{'\n'}{new Date(item.leftclass).toString().substr(4, 11)} @ {item.timeleftclass}{'\n'}{item.comingfrom} -{item.destination} - {item.timeallowedonpass} min.</div>
</div>


</View> */
